/* eslint-disable no-loss-of-precision */
import blank from '../../Blank/blankData'

import NecklaceChain from '../../Jewelry/NecklaceChain'
import NecklaceWhite from '../../Jewelry/NecklaceWhite'
import NecklacePearlGold from '../../Jewelry/NecklacePearlGold'
import NecklacePharoh from '../../Jewelry/NecklacePharoh'

const data = [
  blank,
  {
    id: 'NecklaceChain',
    svg: NecklaceChain,
    positioning: {
      pointNarrow: {
        y: 154.97335815429688,
        scaleX: 1,
      },
      pointMedium: {
        y: 153.46652221679688,
        scaleX: 1,
      },
      pointWide: {
        y: 154.61767578125,
        scaleX: 1,
      },
      roundNarrow: {
        y: 154.38308715820312,
        scaleX: 1,
      },
      roundMedium: {
        y: 153.50387573242188,
        scaleX: 1,
      },
      roundWide: {
        y: 155.47091674804688,
        scaleX: 1,
      },
      squareNarrow: {
        y: 155.83006286621094,
        scaleX: 1,
      },
      squareMedium: {
        y: 154.62118530273438,
        scaleX: 1,
      },
      squareWide: {
        y: 156.39678955078125,
        scaleX: 1,
      },
    },
  },
  {
    id: 'NecklaceWhite',
    svg: NecklaceWhite,
    positioning: {
      pointNarrow: {
        y: 155.85855102539062,
        scaleX: 1,
      },
      pointMedium: {
        y: 154.09059143066406,
        scaleX: 1,
      },
      pointWide: {
        y: 154.61996459960938,
        scaleX: 1,
      },
      roundNarrow: {
        y: 155.08164978027344,
        scaleX: 1,
      },
      roundMedium: {
        y: 154.22462463378906,
        scaleX: 1,
      },
      roundWide: {
        y: 154.86032104492188,
        scaleX: 1,
      },
      squareNarrow: {
        y: 154.03781127929688,
        scaleX: 1,
      },
      squareMedium: {
        y: 153.61099243164062,
        scaleX: 1,
      },
      squareWide: {
        y: 154.99090576171875,
        scaleX: 1,
      },
    },
  },
  {
    id: 'NecklacePearlGold',
    svg: NecklacePearlGold,
    positioning: {
      pointNarrow: {
        y: 157.0236358642578,
        scaleX: 1,
      },
      pointMedium: {
        y: 155.63316345214844,
        scaleX: 1,
      },
      pointWide: {
        y: 156.11888122558594,
        scaleX: 1,
      },
      roundNarrow: {
        y: 156.27293395996094,
        scaleX: 1,
      },
      roundMedium: {
        y: 154.95916748046875,
        scaleX: 1,
      },
      roundWide: {
        y: 156.46444702148438,
        scaleX: 1,
      },
      squareNarrow: {
        y: 156.98226928710938,
        scaleX: 1,
      },
      squareMedium: {
        y: 154.9983367919922,
        scaleX: 1,
      },
      squareWide: {
        y: 156.53623962402344,
        scaleX: 1,
      },
    },
  },
  {
    id: 'NecklacePharoh',
    svg: NecklacePharoh,
    positioning: {
      pointNarrow: {
        y: 153.01644897460938,
        scaleX: 1,
      },
      pointMedium: {
        y: 153.2806854248047,
        scaleX: 1,
      },
      pointWide: {
        y: 154.84364318847656,
        scaleX: 1,
      },
      roundNarrow: {
        y: 156.1934051513672,
        scaleX: 1,
      },
      roundMedium: {
        y: 153.52699279785156,
        scaleX: 1,
      },
      roundWide: {
        y: 153.8429412841797,
        scaleX: 1,
      },
      squareNarrow: {
        y: 153.1456298828125,
        scaleX: 1,
      },
      squareMedium: {
        y: 153.80026245117188,
        scaleX: 1,
      },
      squareWide: {
        y: 153.39938354492188,
        scaleX: 1,
      },
    },
  },
]

export default data
